// src/components/ClientNavBar.tsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ClientNavBar: React.FC = () => {
    const navigate = useNavigate();
    const [isExpanded, setIsExpanded] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('clientToken');
        window.dispatchEvent(new Event('clientAuthChange'));
        navigate('/client/login');
        setIsExpanded(false);
    };

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container-fluid">
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={handleToggle}
                    data-bs-toggle="collapse"
                    data-bs-target="#clientNavbarNav"
                    aria-controls="clientNavbarNav"
                    aria-expanded={isExpanded}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div
                    className={`collapse navbar-collapse ${isExpanded ? 'show' : ''}`}
                    id="clientNavbarNav"
                >
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link
                                className="nav-link"
                                to="/client/dashboard"
                                onClick={() => setIsExpanded(false)}
                            >
                                Dashboard
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link"
                                to="/client/forms"
                                onClick={() => setIsExpanded(false)}
                            >
                                Forms
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link"
                                to="/client/contracts"
                                onClick={() => setIsExpanded(false)}
                            >
                                Contracts
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link"
                                to="/client/account"
                                onClick={() => setIsExpanded(false)}
                            >
                                Account
                            </Link>
                        </li>
                    </ul>
                    <button
                        onClick={handleLogout}
                        className="btn btn-outline-danger ms-auto"
                    >
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default ClientNavBar;